import { useQuery } from "@tanstack/react-query"

import { v1FetchChat } from "@be-miniapp/api"

export const rideChatDataKey = {
  all: ["ride", "chat"],
  engagementId: (engagementId: number | undefined) => [
    ...rideChatDataKey.all,
    engagementId,
  ],
}

interface RideChatDataParams {
  data: {
    engagementId: number | undefined
  }
  refetchInterval?: number
  enabled?: boolean
  apiOptions?: Record<string, unknown>
}

export function useRideChatData({
  data: { engagementId },
  refetchInterval,
  enabled = true,
  apiOptions,
}: RideChatDataParams) {
  return useQuery({
    queryKey: rideChatDataKey.engagementId(engagementId),
    queryFn: async () => {
      return v1FetchChat(
        {
          engagement_id: `${engagementId}`,
          service_type: 1,
          login_type: 0,
        },
        apiOptions
      )
    },
    enabled: !!engagementId && enabled,
    refetchInterval: refetchInterval ?? 10000,
    retry: false,
  })
}
